export default __webpack_public_path__ + "assets/69492300e05ffa0d60c1ea1963061ef8.jpg";